import { createContext, type ReactNode, useContext } from "react";
import type { FormEditorStore } from "../../state/form-editor-store";
import type { BuilderNode } from "../../types";

/**
 * Narrow store surface for form-builder rows so they do not depend on Zustand directly
 * (easier tests and alternate backends).
 */
export interface FormBuilderCanvasContextValue {
	nodes: Record<string, BuilderNode>;
	rootIds: string[];
	clearSectionFields: FormEditorStore["clearSectionFields"];
	deleteNode: FormEditorStore["deleteNode"];
	moveField: FormEditorStore["moveField"];
}

const FormBuilderCanvasContext =
	createContext<FormBuilderCanvasContextValue | null>(null);

export function FormBuilderCanvasProvider({
	value,
	children,
}: {
	value: FormBuilderCanvasContextValue;
	children: ReactNode;
}) {
	return (
		<FormBuilderCanvasContext.Provider value={value}>
			{children}
		</FormBuilderCanvasContext.Provider>
	);
}

export function useFormBuilderCanvas(): FormBuilderCanvasContextValue {
	const ctx = useContext(FormBuilderCanvasContext);
	if (!ctx) {
		throw new Error(
			"useFormBuilderCanvas must be used within FormBuilderCanvasProvider",
		);
	}
	return ctx;
}
